'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBook = function IoIosBook(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.8 5c2.7 0 5.2 0.8 6.6 2.4v27.6h-0.2c-0.6-2.8-3.3-5-6.4-5-2.6 0-5.1 1.3-6.1 3.3h-1.7v-22.1c0-4.2 3.5-6.2 7.8-6.2z m14.4 0c4.3 0 7.8 2 7.8 6.2v22.1h-1.7c-1.3-2.4-3.5-3.3-6.1-3.3-3.1 0-5.8 2.2-6.4 5h-0.2v-27.6c1.4-1.6 3.9-2.4 6.6-2.4z' })
        )
    );
};

exports.default = IoIosBook;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-book.js
// module id = 2570
// module chunks = 168707334958949